<template>
    <!-- banner -->
        <div class="home-banner " :style="{'height':height}">
            <div class="banner-cont"> 
                <p class="cont-tit" v-show="tit">{{tit}}</p>
                <div class="search-cont" >
                    <el-input class="search-input" @keyup.enter.native="search_click" v-model="searchVal" placeholder="请输入内容"></el-input> 
                    <div class="search-btn ">
                        <div class="ai-btn" @click="search_click">
                            <span class="icon search-icon"></span>
                            <span class="search-txt" >搜索</span> 
                        </div>
                    </div>
                </div>   
            </div> 
        </div>
</template>

<script> 
export default {
    props: { 
        //是否打开新页面
        isNewPage:{
            type: Boolean,
            default:false
        },
        //banner高度
        height:{
            type:String,
            default:'200px'
        },
        //检索调整到的页面
        toPath:{
            type:String,
            default:''
        },
        tit:{
            type:String,
            default:''
        }
    },
    components: {},
    data() {
        return {
            searchVal:'',
            wordList:[
                {val:'大黄'},
                {val:'人参'},
                {val:'中风'},
                {val:'咳喘'},
            ]
        }
    },
    watch: {},
    mounted() { 
    },
    methods: {
        toPage(path,word){    
            let query={
                word,
            };  
            let url= this.$router.resolve({
                path,
                query,
            }) 
            this.$windowOpen({ url:url.href,isLogin:path=='aiAnswer'?true:false} )
        },
        search_click(){ 
            if(!this.searchVal){
                this.$message.warning('请输入检索内容～')
                return
            }
            if(!/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(this.searchVal)){
                this.$message.warning('检索词只能包含汉字、数字、字母')
                return
            }
            //如果是在二级检索页，就调用对应的页面的banner_search，如果在其他页面就跳转到globalHotWord页面 this.$route.path !='/globalHotWord'
            if(this.isNewPage){
                this.toPage(this.toPath,this.searchVal) 
            }else{
                this.$emit('banner_search',this.searchVal) 
            }
        },
        clear_search(){
            this.searchVal='';
        }
    }
}
</script>
<style lang='less' scoped>
.home-banner{
    width: 100%;
    min-width: 1200px;
    height: 340px; 
    background: url('../../assets/images/home/banner-bg.png') no-repeat center;
    background-size: cover;
    display: flex;
    align-items: center;
    .banner-cont{
        width: 940px;
        margin:0 auto ; 
        .cont-tit{
            // height:80px ;
            text-align: center;
            font-size: 30px;
            font-weight: bold;
            line-height: 40px;
            color: #fff;
            padding-bottom:20px ;
            letter-spacing:10px;
        }
        .search-cont{
            width:100%;
            height: 56px;
            display: flex;
            border-radius: 12px;
            overflow: hidden; 
            .search-btn{
                width: 130px;
                border-radius: 0;
            }
        }
        .search-input{
            // width: 648px;  
            &.cont-w{
                width: 868px;
            }

        } 
        ::v-deep .el-input__inner{ 
            height:  56px;
            background:rgba(255, 255, 255, .9);
            border-radius: 12px 0 0 12px;  
            color: #396de7;
            font-weight: bold;
            font-size: 16px;
            &::-webkit-input-placeholder{
                -webkit-text-fill-color: #a6a6a6;
            }
            &::-moz-placeholder {
                color:  #a6a6a6; /* 例如：color: #FF0000; */
            }
            &:-ms-input-placeholder {
                color:  #a6a6a6;  /* 例如：color: #FF0000; */
            }
                
            &:-moz-placeholder {
                color:  #a6a6a6;  /* 例如：color: #FF0000; */
            }
        } 
        .search-btn{ 
            background-color: #ffffff;
            // border-radius: 12px;
            width: 135px;
            height: 56px; 
            line-height: 56px;
            border-radius: 12px;
            cursor: pointer;
            .ai-btn{
                display: flex;
                align-items: center;
                justify-content: center
            }
            .icon{ 
                width: 24px;
                height: 24px; 
                margin-right: 10px;
            }
            .search-icon{
                background: url('../../assets/images/home/search-icon.png') no-repeat;
                background-size: contain;
            }
            .ai-icon{ 
                background: url('../../assets/images/home/ai-icon.png') no-repeat;
                background-size: contain;
            }
            .search-txt{
                background-image: linear-gradient(
                    270deg,
                    rgba(129, 255, 217, 1) 0,
                    rgba(103, 238, 255, 1) 11.146801%,
                    rgba(70, 180, 255, 1) 33.139325%,
                    rgba(22, 93, 255, 1) 100%
                    ); 
                    overflow-wrap: break-word;
                    color: rgba(22, 93, 255, 1);
                    font-size: 18px;
                    font-family: PingFang-SC-Medium;
                    font-weight: normal;
                    text-align: left;
                    white-space: nowrap; 
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent; 
            }
        }
    }
}
</style>
